/**
 * Shared date formatting helpers for UniHub.
 * Kai's preferred formats:
 *   - Full date:  "DD Mmm YYYY"  (e.g. "28 Apr 2026")
 *   - Date+time:  "DD Mmm YYYY HH:MM"  (e.g. "28 Apr 2026 14:32")
 *   - Month only: "Mmm YYYY"  (e.g. "Apr 2026")
 */
const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

/** Format anything date-ish to "DD Mmm YYYY". Returns "" for falsy. */
export function fmtDate(input) {
  if (!input) return '';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

/** Format anything date-ish to "DD Mmm YYYY HH:MM". */
export function fmtDateTime(input) {
  if (!input) return '';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()} ${hh}:${mm}`;
}

/**
 * Format a year-month value to "Mmm YYYY".
 * Accepts: "YYYY-MM", "YYYY-MM-DD", a Date, or any parseable date string.
 */
export function fmtMonth(input) {
  if (!input) return '';
  // Plain "YYYY-MM" string
  if (typeof input === 'string' && /^\d{4}-\d{2}/.test(input)) {
    const y = input.slice(0, 4);
    const mi = Number(input.slice(5, 7)) - 1;
    if (mi >= 0 && mi < 12) return `${MONTHS[mi]} ${y}`;
  }
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  return `${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

/** Today's date as "DD Mmm YYYY". */
export function fmtToday() {
  return fmtDate(new Date());
}
